import {
    buildArrayFromRange,
    buildWithBothLeftAndRightEllipsis,
    buildWithLeftEllipsis,
    buildWithRightEllipsis,
} from "./builders";
import { GetPagesOptionsParams } from "./types";

export const getPagesOptions = ({
    currentPage,
    totalPages,
}: GetPagesOptionsParams): (number | string)[] => {
    const siblingCount = 1;

    // siblingCount + firstPage + lastPage + currentPage + 2*ELLIPSIS
    const totalPageNumbers = siblingCount + 5;

    if (totalPageNumbers >= totalPages) {
        return buildArrayFromRange(1, totalPages);
    }

    const leftSiblingIndex = Math.max(currentPage - siblingCount, 1);
    const rightSiblingIndex = Math.min(currentPage + siblingCount, totalPages);

    const shouldShowLeftEllipsis = leftSiblingIndex > 2;
    const shouldShowRightEllipsis = rightSiblingIndex < totalPages - 2;

    const firstPageIndex = 1;
    const lastPageIndex = totalPages;

    if (!shouldShowLeftEllipsis && shouldShowRightEllipsis) {
        return buildWithRightEllipsis({ siblingCount, totalPages });
    }

    if (shouldShowLeftEllipsis && !shouldShowRightEllipsis) {
        return buildWithLeftEllipsis({
            firstPageIndex,
            siblingCount,
            totalPages,
        });
    }

    if (shouldShowLeftEllipsis && shouldShowRightEllipsis) {
        return buildWithBothLeftAndRightEllipsis({
            firstPageIndex,
            lastPageIndex,
            leftSiblingIndex,
            rightSiblingIndex,
        });
    }

    return [];
};
